import axios from 'axios';

export class StudioApi {
  constructor() {
    this.baseUrl = '/stage-ajax/studio-picker/';
  }

  getFolder(folderId = '') {
    return axios.get(`${this.baseUrl}?studioFolder=${folderId}`).then(res => res.data);
  }
}

export default new StudioApi();
